import { render, staticRenderFns } from "./alipayConfig.vue?vue&type=template&id=c4a04c3c"
import script from "./alipayConfig.vue?vue&type=script&lang=js"
export * from "./alipayConfig.vue?vue&type=script&lang=js"
import style0 from "./alipayConfig.vue?vue&type=style&index=0&id=c4a04c3c&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4a04c3c')) {
      api.createRecord('c4a04c3c', component.options)
    } else {
      api.reload('c4a04c3c', component.options)
    }
    module.hot.accept("./alipayConfig.vue?vue&type=template&id=c4a04c3c", function () {
      api.rerender('c4a04c3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/alipayConfig.vue"
export default component.exports